/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AdhocInMeetingType = typeof AdhocInMeetingType[keyof typeof AdhocInMeetingType] | null;


export const AdhocInMeetingType = {
  candidate_interview: 'candidate_interview',
  role_intake: 'role_intake',
  sourcing_intake: 'sourcing_intake',
  client_intake: 'client_intake',
  panel_debrief: 'panel_debrief',
  reference_check: 'reference_check',
  pipeline_review: 'pipeline_review',
  internal_other: 'internal_other',
} as const;
